export const featuredAmenitiesConfig = [
    {
        keywords: ['alberca privada', 'private pool'],
        icon: 'icons-pool1'
    },
    {
        keywords: ['jacuzzi', 'bañera hidromacaje', 'hot tub', 'whirlpool'],
        icon: 'icons-hot-tub-person-outline'
    },
    {
        keywords: ['botella de vino espumoso', 'sparkling wine bottle'],
        icon: 'icons-champagne-glass-outline'
    },
    {
        keywords: ['botella de vino', 'wine bottle'],
        icon: 'icons-wine-bottle-outline'
    },
    {
        keywords: ['cafetera', 'coffee maker'],
        icon: 'icons-coffee-pot-outline'
    },
    {
        keywords: ['rooms / entrada', 'entrada', 'room entrance'],
        icon: 'icons-door-open-outline'
    },
    {
        keywords: ['aire acondicionado / calefacción', 'aire acondicionado', 'calefacción', 'air conditioning', 'heating'],
        icon: 'icons-air-conditioner-outline'
    },
    {
        keywords: ['balcón / terraza', 'balcón', 'terraza', 'balcony', 'terrace'],
        icon: 'icons-bench-tree-outline'
    },
    {
        keywords: ['chimenea', 'fireplace'],
        icon: 'icons-fireplace-outline'
    },
    {
        keywords: ['centro de lavado', 'laundry room'],
        icon: 'icons-dryer-outline'
    },
    {
        keywords: ['cocina', 'kitchen', 'kitchenette'],
        icon: 'icons-coffee-pot-outline'
    },
    {
        keywords: ['horno de microondas', 'microwave'],
        icon: 'icons-microwave-outline'
    },
    {
        keywords: ['refrigerador', 'refrigerator', 'fridge'],
        icon: 'icons-refrigerator-outline'
    },
    {
        keywords: ['sofá cama', 'sofa bed'],
        icon: 'icons-couch-outline'
    },
    {
        keywords: ['caja de seguridad', 'safe', 'safety box'],
        icon: 'icons-vault-outline'
    },
    {
        keywords: ['vestidor', 'walk-in closet', 'dressing room'],
        icon: 'icons-clothes-hanger-outline'
    },
];